<section data-test="x9GTLci3">
  <div data-test="EGuZKL4v" class="modules-container">
    <h1 data-test="Y3ra9O6S" class="text-center">Access Denied</h1>
    <p data-test="19Fpu1Nq" class="text-center">
      You do not have permission to access this page.
    </p>
    <p data-test="qGRT7Ska" class="text-center">
      Please contact your administrator if you believe this is an error.
    </p>
  </div>
</section>
